import { css } from "lit";

export const analyticsPageStyles = css`
  .analytics-filters {
    display: flex;
    justify-content: space-between;
    align-items: center;

    group-button {
      white-space: nowrap;
      --wow-button-subtle-color: var(--sds-color-text-default-secondary);
    }

    select {
      padding: var(--sds-size-space-200) var(--sds-size-space-400);
      outline: none;
      font:
        var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 100%
          var(--sds-typography-family-body),
        sans-serif;

      border-radius: var(--sds-size-radius-400);
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
      background: var(--sds-color-background-default-secondary);
      cursor: pointer;
    }
  }

  .analytics-overview {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: var(--sds-size-space-600);
    margin-top: var(--sds-size-space-800);
    overflow: auto;
  }

  .analytics-visualization {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .analytics-cards {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .analytics-label {
    margin: 0;
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
  }

  .analytics-subscribers {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .subscribers-card {
    cursor: pointer;
  }

  .subscribers-button {
    border: none;
    background: transparent;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) / 140%
      var(--sds-typography-family-body);
    border-radius: 4px;
    transition: box-shadow 0.2s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sds-size-space-100);
    padding: 0;
  }

  .analytics-stats {
    display: flex;
    flex-wrap: wrap;
    gap: var(--sds-size-space-600);
  }

  .analytics-card {
    display: flex;
    flex-grow: 1;
    flex-flow: column wrap;
    box-sizing: border-box;
    height: var(--sds-size-space-4000);
    padding: 16px;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 4px;
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);

    &.chart {
      height: auto;
    }

    &.centered {
      justify-content: center;
    }
  }

  .post-cards-grid {
    display: grid;
    padding: var(--sds-size-space-600);
    border-radius: 4px;
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    box-sizing: border-box;
    margin-bottom: var(--sds-size-space-800);
    margin-top: var(--sds-size-space-800);
    overflow-x: auto;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: var(--sds-size-space-400);
    width: 100%;
    align-content: start;
  }

  .links-sub-tabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: var(--sds-size-space-600);
    margin-top: var(--sds-size-space-400);
  }

  .links-sub-tabs group-button {
    --wow-button-min-width: 120px;
  }

  .link-cards {
    display: grid;
    padding: var(--sds-size-space-600);
    border-radius: 4px;
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    width: 100%;
    box-sizing: border-box;
    margin-bottom: var(--sds-size-space-800);
    margin-top: var(--sds-size-space-800);
    align-content: start;
    gap: var(--sds-size-space-400);
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
      padding: var(--sds-size-space-300);
      gap: var(--sds-size-space-200);
    }
  }

  .link-card-icon {
    grid-area: icon;
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: var(--sds-size-radius-400);
  }

  .link-card {
    display: grid;
    align-items: center;
    width: 100%;
    padding: var(--sds-size-space-300) var(--sds-size-space-400);
    border: 2px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background: var(--sds-color-background-default-tertiary);
    text-align: left;
    box-sizing: border-box;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    cursor: pointer;

    grid-template:
      "icon statistics cta" auto
      / auto 1fr auto;
    gap: var(--sds-size-space-400);
  }

  .link-card .link-card-content {
    grid-area: statistics;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
    min-width: 0;
    overflow: hidden;
  }

  .link-card .link-card-url {
    display: block;
    margin: 0;
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-label-size-small);
    font-weight: var(--sds-typography-weight-medium);
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .link-card .link-card-title {
    display: block;
    margin: 0;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .analytics-title {
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) / 140%
      var(--sds-typography-family-body);
  }

  .analytics-data {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--sds-size-space-300);
  }

  .analytics-value {
    color: var(--sds-color-text-default-default);
    font: var(--sds-typography-weight-medium) var(--sds-typography-subheading-size) / 150%
      var(--sds-typography-family-title);
  }

  .analytics-growth {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) / 140%
      var(--sds-typography-family-body);
  }

  .analytics-growth .upwards,
  .analytics-growth .idle,
  .analytics-growth .downwards {
    display: inline-flex;
    align-items: center;
    gap: var(--sds-size-space-100);
  }

  .analytics-growth .upwards {
    color: var(--sds-color-text-positive-secondary);
  }

  .analytics-growth .idle {
    color: var(--sds-color-text-warning-secondary);
  }

  .analytics-growth .downwards {
    color: var(--sds-color-text-danger-secondary);
  }

  .analytics-chart {
    width: 100%;
  }

  .analytics-chart #chart {
    width: 100%;
  }

  #custom-range-form {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .statistics-metrics {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    overflow: auto;
  }

  .statistics-metrics .analytics-card.chart {
    min-height: 350px;
    padding: var(--sds-size-space-600);
  }

  .statistics-metrics .analytics-card.chart canvas {
    width: 100%;
    max-height: 300px;
  }

  .statistics-metrics .analytics-card.chart p {
    margin: 0;
    margin-bottom: var(--sds-size-space-600);
  }

  @media (max-width: 767px) {
    .analytics-filters {
      flex-direction: column;
      gap: var(--sds-size-space-600);
      align-items: stretch;

      --wow-button-width: 100%;

      select {
        width: 100%;
      }
    }

    .analytics-stats {
      flex-wrap: wrap;
    }

    .statistics-metrics {
      max-height: 100vh;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: var(--sds-size-space-400);
    }

    .statistics-metrics .analytics-stats {
      flex-shrink: 0;
    }

    .statistics-metrics .analytics-visualization {
      flex-shrink: 0;
      min-height: 200px;
    }

    .statistics-metrics .link-card {
      flex-shrink: 0;
      min-height: 60px;
      margin-top: var(--sds-size-space-400);
    }
  }

  @media (max-width: 480px) {
    .statistics-metrics {
      max-height: 100vh;
      padding: var(--sds-size-space-200);
    }

    .statistics-metrics .analytics-card.chart {
      min-height: 180px;
      padding: var(--sds-size-space-400);
    }

    .statistics-metrics .link-card {
      min-height: 70px;
      padding: var(--sds-size-space-400);
    }

    .statistics-metrics .analytics-stats {
      gap: var(--sds-size-space-300);
    }
  }
`;
